import MainLayout from "@/components/layout/MainLayout.vue";
import Pagination from "laravel-vue-pagination";
import moment from "moment";
import axios from "axios";
import { mapGetters } from "vuex";
import { ConvertNumService } from '@/assets/js/convertNumberService.js';
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
//import { fetchNotificationCount } from "@/services/common/notification-service";

const convertNumberService = new ConvertNumService();

export default {
    name: "newsList",

    components: {
        MainLayout,
        Pagination,
        AdvancedLaravelVuePaginate
    },

    data() {
        return {
            pg_status:false,
            pg_sortby: false,
            keyword: "",
            sortBy: "",
            news: {},
            lastPage: "",
            currentPage: ""
        };
    },

    computed: {
        ...mapGetters(["teacherId", "studentId", "userType"]),
    },

    filters: {
        shorttext(value, limit) {
            if (value) {
                return value.substring(0, limit);
            }
        },
        setMoment: function (date) {
            return moment(date).format("DD MMMM YYYY");
        }
    },

    methods: {
        getNews(page = 1) {
            axios.get("/news/list?page=" + page)
                .then((response) => {
                    this.news = response.data;                    
                    this.news.total = convertNumberService.convertEng2Mm(this.news.total);
                    this.lastPage = convertNumberService.convertEng2Mm(this.news.last_page);
                    this.currentPage = convertNumberService.convertEng2Mm(this.news.current_page);
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("New List API Error", error);
                });
        },

        onChange(page = 1) {
            axios.get("/news/list/filter?page=" + page, {
                    params: {
                        news_name: this.keyword,
                        orderBy: this.sortBy
                    }
                })
                .then((response) => {
                    this.pg_sortby = true,
                    this.news = response.data;                    
                    this.news.total = convertNumberService.convertEng2Mm(this.news.total);
                    this.lastPage = convertNumberService.convertEng2Mm(this.news.last_page);
                    this.currentPage = convertNumberService.convertEng2Mm(this.news.current_page);
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("Sort New API Error", error);
                });
        },
        
        search(page = 1) {
            axios.get("/news/list/search?page=" + page, {
                    params: {
                        keyword: this.keyword
                    }
                })
                .then((response) => {
                    this.pg_status = true;
                    this.news = response.data;                    
                    this.news.total = convertNumberService.convertEng2Mm(this.news.total);
                    this.lastPage = convertNumberService.convertEng2Mm(this.news.last_page);
                    this.currentPage = convertNumberService.convertEng2Mm(this.news.current_page);
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("New Search API Error", error);
                });
        },
    },

    mounted() {
        this.getNews();
        //fetchNotificationCount();
    }
};
